import { Container } from "lucide-react";

export default function AssetPlaceholder({ label, big, className = "" }) {
  return (
    <div
      className={`relative flex flex-col items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 overflow-hidden ${className}`}
      data-testid="asset-placeholder"
      role="img"
      aria-label={label}
    >
      {big && (
        <span className="absolute font-heading font-extrabold text-slate-900/[0.06] text-[9rem] leading-none select-none" aria-hidden="true">
          {big}
        </span>
      )}
      <div className="relative border-2 border-dashed border-slate-300 rounded-lg px-5 py-4 mx-4 text-center bg-white/50">
        <Container className="h-6 w-6 mx-auto text-slate-400 mb-2" />
        <p className="text-[11px] leading-snug text-slate-500 font-medium max-w-[220px]">{label}</p>
      </div>
    </div>
  );
}
